<template>
    <div class="slide full" :style="slide.photo ? `background-image: url(${slide.photo});` : slide.backgroundColor ? `background-color: ${slide.backgroundColor};` : 'transparent;'">
        <Loading v-if="isLoading"></Loading>
        <h2>
            <a href="#" @click.prevent="openSlidePanel" v-if="slide.details">{{slide.subtitle}}</a>
            <template v-else>{{slide.subtitle}}</template>
        </h2>
        <div><a class="plus" href="#" @click.prevent="openSlidePanel" v-if="slide.details"></a></div>
        <img :src="slide.photo" alt="" v-if="slide.photo" v-show="false" @load="onImgLoad" />
    </div>
</template>

<script>
import Loading from './Loading.vue';
import loaderLoaderMixin from '../mixins/loader';

export default {
    props: ['slide'],
    components: {Loading},
    mixins: [loaderLoaderMixin],
    methods: {
        openSlidePanel() {
            this.$root.$emit('openSlidePanel', this.slide.details)
        },
        onImgLoad() {
            this.isLoading = false;
        }
    },
    mounted() {
        if (!this.slide.photo) {
            this.isLoading = false;
        }
    }
}
</script>

<style scoped>
.full {
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
h2 {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 48px;
    font-weight: 400;
    margin-bottom: 0px;
    padding: 0 40px;
}
h2 a {
    color: #c00;
    text-shadow: 0px 0px 6px rgba(51,51,51,0.5);
    display: inline-block;
    margin-bottom: 10px;
}
h2 a:hover, h2 a:focus {
    color: #c00;
}
h2 a:after {
    content: ''; 
    display: block; 
    width: 0; 
    height: 3px; 
    background: #c00; 
    transition: width .3s;
}
h2 a:hover:after {
    width: 100%;
}
.slide.full h3 {
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 1.5em;
    font-weight: 300;
    text-shadow: 0px 0px 4px rgba(51,51,51,0.8);
    padding: 0 40px;
}

/* MEDIA QUERIES */
@media (max-width: 575px) {
    h2 a {
        font-size: 36px;
    }
    .slide.full h3 {
        font-size: 1.2em;
    }
}
</style>